import React from 'react'
import styled from 'styled-components'

const DescriptionParagraph = styled.p`
  margin-top: 12px;
`

export const UploadDeviceCheckKeyDescription: React.FC = () => (
  <DescriptionParagraph>
    Your DeviceCheck Key allows you to use the iOS device check capabilities.
    <br />
    Learn more about{' '}
    <a
      href="https://int.sudoplatform.com/docs/users/ios/integrating.html"
      className="automation-UploadDeviceCheckKeyDescriptionLink"
      target="_blank"
      rel="noopener noreferrer"
    >
      {' '}
      iOS DeviceCheck Keys
    </a>
    .
  </DescriptionParagraph>
)
